import { useState, useEffect } from 'react';
import contentfulClient from '../services/contentful';

const CONTENTFUL_BLOG_POST_TYPE_ID = 'blogPost';

export function useBlogPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!contentfulClient) {
      setPosts([
        {
          sys: { id: '1', createdAt: new Date().toISOString() },
          fields: {
            title: 'Sample Blog Post 1: AI in 2025',
            slug: 'sample-post-1',
            excerpt: 'This is a brief summary of the first sample blog post. It talks about the future of AI.',
            featuredImage: { fields: { file: { url: 'https://placehold.co/600x400/7c3aed/ffffff?text=AI+Future' } } },
            content: 'Full content of sample post 1...'
          }
        },
        {
          sys: { id: '2', createdAt: new Date(Date.now() - 86400000).toISOString() },
          fields: {
            title: 'Sample Blog Post 2: Cloud Strategies',
            slug: 'sample-post-2',
            excerpt: 'An overview of effective cloud computing strategies for modern businesses.',
            featuredImage: { fields: { file: { url: 'https://placehold.co/600x400/10b981/ffffff?text=Cloud+Strategy' } } },
            content: 'Full content of sample post 2...'
          }
        }
      ]);
      setLoading(false);
      setError('Contentful client not configured. Displaying sample data. Please check your SPACE_ID and ACCESS_TOKEN.');
      return;
    }
    contentfulClient.getEntries({ content_type: CONTENTFUL_BLOG_POST_TYPE_ID, order: '-sys.createdAt' })
      .then((response) => {
        setPosts(response.items);
        setLoading(false);
      })
      .catch((err) => {
        setError('Failed to load blog posts. Please ensure Contentful is set up correctly.');
        setLoading(false);
        setPosts([
          { sys: { id: 'error1', createdAt: new Date().toISOString() }, fields: { title: 'Error: Could Not Load Post', slug: 'error-post', excerpt: 'There was an issue fetching this post.', featuredImage: { fields: { file: { url: 'https://placehold.co/600x400/ef4444/ffffff?text=Error' } } } } }
        ]);
      });
  }, []);

  return { posts, loading, error };
} 